<ul class="info-list" style="list-style-type: none; margin: 0; padding: 0">
    <ng-content></ng-content>
</ul>
